<template>
    <v-container class="inputContainer">
        <message-component id="message" v-model="isMessage" :success="this.message.success" style="white-space:pre-wrap; word-wrap:break-word;">{{ message.text }}</message-component>
        <v-overlay :value="sending" z-index="10000">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
            <span class="loading">処理中です...</span>
        </v-overlay>

        <v-row style="margin-bottom:10px" justify="center">
            <h3 v-if="inputs.length > 0">あなたに割り当てられた入力項目をクリックし、入力を完了してください。</h3>
            <h3 v-else>内容をご確認のうえ、確認ボタンをクリックしてください。</h3>
        </v-row>
        <v-row justify="center">
            <v-card color="grey lighten-3">
                <v-tabs dark background-color="grey" show-arrows v-model="fileTab">
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab
                        v-for="(pdfObj) in Object.entries(this.pdfs)"
                        :key="pdfObj[0]"
                        :disabled="pdfLoading"
                        v-on:click="changePdf(pdfObj[0])"
                    >
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <span
                                class="info-to"
                                v-bind="attrs"
                                v-on="on"
                                >
                                    {{ pdfObj[1].filename | omittedText }}
                                </span>
                            </template>
                            <span>{{ pdfObj[1].filename }}</span>
                        </v-tooltip>

                        
                    </v-tab>
                </v-tabs>
                <sign-pdf-document-component
                    v-for="(pdfObj, index) in Object.entries(this.pdfs)"
                    :key="index"
                    v-show="currentPdfId==pdfObj[0]"
                    scale="1"
                    :url="baseUrl+pdfObj[0]"
                    :pdfId="pdfObj[0]"
                    :destinations="destinations"
                    :colorsIdMap="colorsIdMap"
                    :bgColorsIdMap="bgColorsIdMap"
                    :registeredInputs="registeredInputs[pdfObj[0]]"
                    :otherInputs="otherInputs[pdfObj[0]]"
                    :maxObjId="maxObjId"
                    :showOtherInputs="showOtherInputs"
                    ref="document"
                    @loading="loading"
                    @updateInput="updateInput"
                    />
            </v-card>
            <v-card
                v-if="showOtherInputs"
                width="200px"
            >
                <v-card-title>
                    凡例
                </v-card-title>
                <destination-list-component
                    :destinations="destinations"
                    :colors="colors"
                    :bgcolors="bgcolors"
                >
                </destination-list-component>
            </v-card>
        </v-row>
        <v-row justify="center" width="800">
            <v-col cols="2">
                <v-btn block color="red" class="white--text" v-on:click="openAgreeDialog" v-if="isAuthorizer">承認</v-btn>
                <v-btn block color="red" class="white--text" v-on:click="openAgreeDialog" v-else >確認</v-btn>
            </v-col>
        </v-row>
        <v-dialog
            v-model="isAgree"
            width="60%"
        >
            <!--<template v-slot:activator="{ on, attrs}">-->
            <!--    <v-img-->
            <!--        max-height="40"-->
            <!--        max-width="40"-->
            <!--        width="40"-->
            <!--        height="40"-->
            <!--        :src="currentSealData"-->
            <!--        :contain="true"-->
            <!--        v-bind="attrs"-->
            <!--        v-on="on"-->
            <!--        v-show="currentSealData != ''"-->
            <!--        content-class="seal-preview"-->
            <!--    >-->
            <!--    </v-img>-->
            <!--    <span-->
            <!--        class="circle"-->
            <!--        :style="'border: solid 3px '+colorsIdMap[currentDestinationId]"-->
            <!--        v-bind="attrs"-->
            <!--        v-on="on"-->
            <!--        v-show="currentSealData === ''"-->
            <!--    >-->
            <!--    </span>-->
            <!--</template>-->
            <v-card color="#F4FEFB">
                <v-container class="py-6">
                    <v-row  justify="center">
                        <div class="justify-center text-h4" v-if="isAuthorizer">承認を完了してよろしいですか？</div>
                        <div class="justify-center text-h4" v-else >契約の内容に同意して確認を完了してよろしいですか？</div>
                    </v-row>
                    <v-row justify="center">
                        <v-col cols="2">
                            <v-btn block color="white" v-on:click="cancelAgree">キャンセル</v-btn>
                        </v-col>
                        <v-col cols="3">
                            <v-btn block color="red" class="white--text" v-on:click="agree" v-if="isAuthorizer">承認する</v-btn>
                            <v-btn block color="red" class="white--text" v-on:click="agree" v-else>同意して確認を完了する</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import { colorList, bgColorList, colorListIdMap } from '../../common/colorUtil.js';
    export default {
        props: ['destinations', 'pdfs', 'agreementObjId', 'registeredInputs', 'maxObjId', 'accessCode', 'hash', 'isAuthorizer', "otherInputs", "showOtherInputs"],
        data: function () {
            return {
                fileTab: null,
                inputs: {},
                inputNum: 0,
                url: undefined,
                currentPdfId: 0,
                pdfLoading: false,
                baseUrl: 'get-pdf/',
                pdfIdMap: {},
                colors: [],
                bgcolors: [],
                colorsIdMap: {},
                bgColorsIdMap: {},
                sending: false,
                isAgree: false,
                
                currentDestinationId: '',
                currentSealData: '',
                message: {
                    success: false,
                    text: '',
                },
                isInputFocusCallback: false,
                focusSelectr: '',
            };
        },
        computed: {
            isMessage: {
                get() {
                    return this.message.text != '';
                },
                set(value) {
                    if (!value) {
                        this.message.text = '';
                    }
                }
            },
        },
        filters: {
            omittedText(text) {
             // 11文字目以降は"…"
             return text.length > 10 ? text.slice(0, 10) + "…" : text;
            },
        },
        created: function () {
            this.currentDestinationId = this.destinationId;
            this.currentPdfId = Object.entries(this.pdfs)[0][0];
            // pdfの取得URL
            this.url = 'get-pdf/'+Object.entries(this.pdfs)[0][0];
            Object.entries(this.pdfs).forEach((val, i) => {
                this.pdfIdMap[val[0]] = i;
            });
            this.colors = colorList;
            this.bgcolors = bgColorList;
            let ids = [];
            this.destinations.forEach(val => {
                ids.push(val.id);
            });
            // 契約送付先IDと色のマッピング作成
            this.colorsIdMap = colorListIdMap(ids, colorList);
            this.bgColorsIdMap = colorListIdMap(ids, bgColorList);
            this.inputs = Object.assign({}, this.registeredInputs);
        },
        methods: {
            changePdf: function (id) {
                this.currentPdfId = id;
            },
            loading: function (isLoading) {
                this.pdfLoading = isLoading;
                if (this.isInputFocusCallback) {
                    this.inputFocusCallback();
                }
            },
            updateInput: function (pdfId, page, objectId, value) {
                // すべての契約書の入力項目更新（最終的にサーバへ送信するデータ）
                if (!(pdfId in this.inputs)) {
                    this.inputs[pdfId] = new Object();
                }
                if (!(page in this.inputs[pdfId])) {
                    this.inputs[pdfId][page] = new Object();
                }
                this.inputs[pdfId][page][objectId] = value;
                this.$emit("updateInput", this.inputs);
            },
            agree: async function () {
                this.sending = true;
                const postUrl = 'sign';
                // 入力内容を送信
                var response = await window.axios.post(
                    postUrl,
                    {
                        'inputs': this.inputs,
                    }
                )
                .catch(response => {
                    console.log(response);
                    this.sending = false;
                });
                
                this.sending = false;
                if (response.data.success) {
                    window.location = "complete";
                } else {
                    console.log(response);
                    if (response.data.message) {
                        this.isAgree = false;
                        this.message.text = response.data.message;
                        this.message.success = false;
                        // エラー対象のPDFを表示する
                        if (response.data.fileId) {
                            this.currentPdfId = response.data.fileId;
                            this.fileTab = Object.keys(this.pdfs).indexOf(response.data.fileId);
                        }
                        if (response.data.pageNum) {
                            this.$refs.document[this.fileTab].currentPage = response.data.pageNum;
                        }
                    }
                }
            },
            openAgreeDialog: function () {
                this.isAgree = true;
            },
            cancelAgree: function () {
                this.isAgree = false;
            },
            inputFocus: async function (fileId, pageNum, item) {
                // console.log(this.currentPdfId);
                let fileTab = Object.keys(this.pdfs).indexOf(fileId);
                this.focusSelectr = '[input_id="' + item[0] + '"]';
                // console.log(this.focusSelectr);
                if (this.currentPdfId != fileId || this.$refs.document[fileTab].currentPage != parseInt(pageNum, 10)) {
                    this.currentPdfId = fileId;
                    this.fileTab = fileTab;
                    // this.$refs.document[this.fileTab].currentPage = parseInt(pageNum, 10);
                    // console.log('pageNum:' + parseInt(pageNum, 10));
                    this.isInputFocusCallback = true;
                    await this.$refs.document[this.fileTab].changePage(parseInt(pageNum, 10));
                } else {
                    this.inputFocusCallback();
                }
            },
            inputFocusCallback: function () {
                this.isInputFocusCallback = false;
                this.$nextTick(function() {
                    let ele = this.$el.querySelector(this.focusSelectr);
                    if (ele != null) {
                        ele.focus();
                    }
                });
            }
        }
    };
</script>

<style scoped>
</style>
